var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73.202,
    height: 73,
    viewBox: "0 0 19.368 19.315",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-134.05 -180.46)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 789.68 -134.57)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m-2406.4 1209.2c-0.8-3.1-3.2-5.6-6.5-6.5-5.7-1.6-28.5-1.6-28.5-1.6s-22.8 0-28.5 1.6c-3.1 0.8-5.6 3.2-6.5 6.5-1.6 5.7-1.6 17.5-1.6 17.5s0 11.8 1.6 17.5c0.8 3.1 3.2 5.6 6.5 6.5 5.7 1.6 28.5 1.6 28.5 1.6s22.8 0 28.5-1.6c3.1-0.8 5.6-3.2 6.5-6.5 1.6-5.7 1.6-17.5 1.6-17.5s-0.1-11.8-1.6-17.5zm-42.2 28.5v-21.9l18.9 10.9z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f78340b61fda6188a532e40ebe68f54d.svg";
export { ForwardRef as ReactComponent };